import moment from '../../../lib/moment.js'
import find from 'lodash/find'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'

/* eslint no-underscore-dangle: 0 */

export const findUserData = (id, users) => {
  let data
  users.map(user => {
    data = find(users, { _id: id })
    return user
  })
  return data
}

export const findProjectData = (id, projects) => {
  let data
  projects.map(project => {
    data = find(projects, { project_id: id })
    return project
  })
  return data
}

export const findName = (id, list) => {
  const data = find(list, {
    _id: id,
  })
  return data ? data.name : '-'
}

export const createApproverList = (list) => {
  const temp = []
  list.map(approver => {
    if (!get(approver, 'is_system_admin') && get(approver, 'is_active') && localStorage.getItem('_id') !== approver._id) {
      temp.push({
        label: `${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
        approver_id: approver._id,
        first_name: approver.first_name,
        last_name: approver.last_name,
        nick_name: approver.nick_name,
      })
    }
    return approver
  })
  return orderBy(temp, ['first_name', 'last_name', 'nick_name'], ['asc', 'asc', 'asc'])
}

export const createLeaveTypeList = (list) => {
  const temp = [{ label: 'Choose Leave Type ID', leave_type_id: '', is_calendar_day: false }]
  list.map((item) => {
    if (item.is_active) {
      temp.push({
        label: `${item.leave_type_code} - ${item.name}`,
        leave_type_id: item._id,
        is_calendar_day: item.is_calendar_day,
      })
    }
    return item
  })
  return temp
}

export const createProjectList = (list) => {
  const temp = []
  list.map((item) => {
    temp.push({ label: `${item.project_code} - ${item.project_name}`, project_id: item.project_id })
    return item
  })
  return temp
}

export const findFullNameByID = (id, list) => {
  const name = find(list, {
    _id: id,
  })
  return name === undefined ? '' : `${name.first_name} ${name.last_name} (${name.nick_name})`
}

export const createCompensateApproverList = (list) => {
  const temp = []
  list.map(approver => {
    if (!get(approver, 'is_system_admin') && get(approver, 'is_active')) {
      temp.push({
        label: `${approver.name} (${approver.nick_name})`,
        name: `${approver.name}`,
        nick_name: approver.nick_name,
        value: approver.id,
        approver_id: approver.id,
      })
    }
    return approver
  })
  return orderBy(temp, ['name', 'nick_name'], ['asc', 'asc'])
}

export const changeDataLeaveHistory = (
  myLeaveRequests, myCompensateRequestsHistory, myCompensateRequests, leaveTypes, users) => {
  const requests = []
  myLeaveRequests.map(m => {
    const myLeave = {}
    const approver = findUserData(m.approver_id, users)
    myLeave.leave_type = findName(m.leave_type_id, leaveTypes)
    myLeave.default_duration = `${moment(m.start_date).format('YYYYMMDD')} - ${moment(m.end_date).format('YYYYMMDD')}`
    myLeave.duration = `${moment(m.start_date).format('DD/MM/YYYY')} - ${moment(m.end_date).format('DD/MM/YYYY')}`
    myLeave.start_date = moment(m.start_date).format('DD/MM/YYYY')
    myLeave.end_date = moment(m.end_date).format('DD/MM/YYYY')
    myLeave.days = get(m, 'days', 0)
    myLeave.leave_time = get(m, 'leave_time', '')
    myLeave.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
    myLeave.default_submit_date = moment(m.created).format('YYYYMMDD')
    myLeave.submit_date = moment(m.created).format('DD/MM/YYYY')
    myLeave.created = moment(m.created).format('DD/MM/YYYY')
    myLeave.status = get(m, 'status', '')
    myLeave.canApprove = get(m, 'canApprove')
    myLeave.canCancel = get(m, 'canCancel')
    myLeave.remark_approver = get(m, 'remark_approver', '')
    myLeave.remark_cancel = get(m, 'remark_cancel', '')
    myLeave.remark_hr = get(m, 'remark_hr', '')
    myLeave.remark_request_user = get(m, 'remark_request_user', '')
    myLeave.attachment_url = get(m, 'attachment_url', '')
    myLeave._id = get(m, '_id')
    requests.push(myLeave)
    return m
  })
  myCompensateRequestsHistory.map(m => {
    const myCompensate = {}
    const approver = findUserData(m.approver_id, users)
    const project = findProjectData(m.project_id,
      myCompensateRequests.prettyProjects)
    myCompensate.leave_type = 'Compensate Work'
    myCompensate.project = project ? `${project.project_code} - ${project.project_name}` : '-'
    myCompensate.default_duration = `${moment(m.start_date).format('YYYYMMDD')} - ${moment(m.end_date).format('YYYYMMDD')}`
    myCompensate.duration = `${moment(m.start_date).format('DD/MM/YYYY')} - ${moment(m.end_date).format('DD/MM/YYYY')}`
    myCompensate.start_date = moment(m.start_date).format('DD/MM/YYYY')
    myCompensate.end_date = moment(m.end_date).format('DD/MM/YYYY')
    myCompensate.status = get(m, 'status', '')
    myCompensate.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
    myCompensate.days = get(m, 'days', 0)
    myCompensate.compensate_time = get(m, 'compensate_time', '')
    myCompensate.default_submit_date = moment(m.created).format('YYYYMMDD')
    myCompensate.submit_date = moment(m.created).format('DD/MM/YYYY')
    myCompensate._id = get(m, '_id')
    myCompensate.remark_approver = get(m, 'remark_approver', '')
    myCompensate.remark_cancel = get(m, 'remark_cancel', '')
    myCompensate.remark_request_user = get(m, 'remark_request_user', '')
    requests.push(myCompensate)
    return m
  })
  return requests
}



// WEBPACK FOOTER //
// ./src/components/my-leave/helpers/my-leave.js